import { IBookItem } from "~/utils/interface";
import { IcoChilli, IcoUnion } from "~/icons";
import React from "react";
import { Link } from "@remix-run/react";
import { Tag } from "~/components";
import classNames from "classnames";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

const Book = ({
  tropes,
  title,
  book_id,
  peppers,
  cover,
  showPeppers,
  showTropes,
  is_free,
  className,
  imageClasses,
  pepperClasses,
  imageHeight,
  imageWidth,
}: IBookItem) => {
  const width = useWindowWidth();
  return (
    <Link
      to={`/books/${book_id}`}
      className={classNames(className && className)}
      style={{ width: !imageClasses && width < 768 ? 200 : undefined }}
    >
      <div className="relative">
        <img
          className={classNames(
            "rounded-lg w-full",
            imageClasses && imageClasses,
          )}
          src={`https://static.wromance.com/cdn-cgi/image/width=${imageWidth || 280},quality=90/${book_id}/${cover}`}
          alt={title}
        />
        {is_free && <Tag />}
      </div>
      {showTropes && (
        <ul className="mt-4 flex flex-wrap justify-center max-lg:border-b-[0.5px] max-lg:border-[rgba(255,_255,_255,_0.1)] max-lg:pb-2 max-lg:min-h-[97px]">
          {tropes.map((trope, indexTrope) => (
            <li
              className="text-white opacity-70 text-[16px] leading-[22px] mr-1"
              key={`trope_${indexTrope}_${book_id}`}
            >
              {indexTrope !== 0 && "• "}
              {trope}
            </li>
          ))}
        </ul>
      )}
      {showPeppers && (
        <div className={classNames(pepperClasses && pepperClasses)}>
          <ul className="flex justify-center mt-2">
            {Array.from({ length: peppers }, (_, index) => (
              <li key={`pepper_${index}_${book_id}`}>
                <img
                  src={IcoChilli}
                  alt={`pepper_${index}`}
                  key={`pepper_${index}`}
                  className="mr-1 h-5 w-5"
                />
              </li>
            ))}
          </ul>
          {pepperClasses && (
            <div className="flex items-center mt-2 text-[13px] leading-[18px] text-[rgba(135,_183,_255,_1)]">
              <IcoUnion className="mr-3" />
              Sample
            </div>
          )}
        </div>
      )}
    </Link>
  );
};

Book.displayName = "Book";
export default Book;
